export const LANG_PT_DICTIONARY = {
  LANG_EN: 'Inglês',
  LANG_ES: 'Espanhol',
  LANG_PT: 'Português',
} as const;
